import {Button, Popover, Tag} from "antd";
import React, {useState, useRef, useEffect} from "react";
import {Modal} from "antd/lib";
import Transfers from "./Transfers";
import TransfersV2 from "./TransfersV2";
import {ReactComponent as TransfersIcon} from '../../assets/icons/Transfers.svg';
import DisplayStop from "../../components/DisplayStop";
import {useAppContext} from "../../libs/contextLib";
import {getUserPreference, setUserPreference} from "../../libs/userPreferencesDb";
import {noop} from "lodash";
import './TransfersV2.css';

const PREF_KEY_USE_TRANSFERS_V2 = 'transfers_use_v2';

const TransfersModal = ({
                            iconOnly,
                            point,
                            routeId,
                            tripId,
                            stopTimeId,
                            width,
                            popPlacement,
                            disabled,
                            setTransfersModalOpen = noop
                        }) => {
    const {isAuthenticated} = useAppContext()
    const [visible, setVisible] = useState(false);
    const [useV2, setUseV2] = useState(false);
    const [v2PreferenceLoaded, setV2PreferenceLoaded] = useState(false);
    const [savingV2, setSavingV2] = useState(false);
    const transfersV2Ref = useRef(null);

    // Load V2 preference from IndexedDB on mount
    useEffect(() => {
        getUserPreference(PREF_KEY_USE_TRANSFERS_V2, false).then((prefersV2) => {
            setUseV2(prefersV2);
            setV2PreferenceLoaded(true);
        });
    }, []);

    // Save V2 preference when user toggles
    const handleSetUseV2 = (value) => {
        setUseV2(value);
        setUserPreference(PREF_KEY_USE_TRANSFERS_V2, value);
    };

    const handleCloseV2 = () => {
        setTransfersModalOpen(false);
        setVisible(false);
    };

    const handleCancelV2 = () => {
        if (transfersV2Ref.current) {
            transfersV2Ref.current.handleCancel();
        }
        handleCloseV2();
    };

    const handleSaveV2 = async () => {
        if (transfersV2Ref.current) {
            setSavingV2(true);
            try {
                await transfersV2Ref.current.saveChanges();
                handleCloseV2();
            } finally {
                setSavingV2(false);
            }
        }
    };

    return (
        <>
            {isAuthenticated &&
                <Popover placement={popPlacement}
                         title={<span>Service transfers</span>}
                         content={<div><p>Edit service transfers at the selected point</p></div>}
                         trigger="hover">
                    <Button disabled={!point?.stopId || disabled}
                            onClick={() => {
                                setTransfersModalOpen(true);
                                setVisible(true)
                            }}
                            className="btn-icon-control icon-button btn-filled btn transfer-icon"><TransfersIcon width={16} height={16}/>{!iconOnly && ' Transfers'}</Button>
                </Popover>
            }
            <Modal
                open={visible}
                width={'94%'} style={{top: 60}}
                title={<div className={"transfers-header d-flex flex-row"}>
                    <div className={""}>{point &&
                        <DisplayStop key={`DisplayStop-${point.stopId}`} stop={point} noRoutes={true}
                                     noInterchange={true} noWarning={true}/>}</div>
                    {useV2 && <Tag color="blue" style={{marginLeft: 8}}>V2 Beta</Tag>}
                </div>}
                onCancel={() => {
                    if (useV2) {
                        handleCancelV2();
                    } else {
                        setTransfersModalOpen(false);
                        setVisible(false);
                    }
                }}
                destroyOnClose={true}
                footer={useV2 ? (
                    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <div>
                            <Button key="back-to-v1" onClick={() => handleSetUseV2(false)} disabled={savingV2}>
                                Back to V1
                            </Button>
                            <Button key="reset" danger disabled={savingV2} onClick={() => transfersV2Ref.current?.resetTransfers?.()} style={{marginLeft: 8}}>
                                Reset
                            </Button>
                        </div>
                        <div>
                            <Button key="cancel" onClick={handleCancelV2} disabled={savingV2} style={{marginRight: 8}}>
                                Cancel
                            </Button>
                            <Button key="save" type="primary" className="btn-primary" onClick={handleSaveV2} loading={savingV2}>
                                Save
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <Button key="try-v2" type="default" onClick={() => handleSetUseV2(true)}>
                            Try V2 Beta
                        </Button>
                        <Button key="back" type="primary" className="btn-primary" onClick={() => {
                            setTransfersModalOpen(false);
                            setVisible(false)
                        }}>
                            Done
                        </Button>
                    </div>
                )}
            >
                {useV2 ? (
                    <TransfersV2
                        ref={transfersV2Ref}
                        point={point}
                        routeId={routeId}
                        tripId={tripId}
                        stopTimeId={stopTimeId}
                    />
                ) : (
                    <Transfers point={point}
                               routeId={routeId} tripId={tripId} stopTimeId={stopTimeId}/>
                )}
            </Modal>
        </>
    );
}

export default React.memo(TransfersModal)
